"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanupPhoneNumberForUI = exports.CONST_TBG__DefaultCountryCode = exports.CONST_TBG__DefaultCountryLocale = exports.CONST_Id = void 0;
exports.CONST_Id = '_id';
exports.CONST_TBG__DefaultCountryLocale = 'IL';
exports.CONST_TBG__DefaultCountryCode = '972';
/**
 * Take an E164 phone number, and returns a local phone number
 * @param phone - E164 phone number
 */
const cleanupPhoneNumberForUI = (phone) => { var _a; return (_a = phone === null || phone === void 0 ? void 0 : phone.replace(`+${exports.CONST_TBG__DefaultCountryCode} `, '0')) === null || _a === void 0 ? void 0 : _a.replace(/ /g, '-'); };
exports.cleanupPhoneNumberForUI = cleanupPhoneNumberForUI;
__exportStar(require("./country/country-codes"), exports);
